import React, { Component, PropTypes } from 'react'
import { Modal, Button } from 'react-bootstrap'

export default class WarningModal extends Component {
  render () {
    let { messages, popupError, onClose } = this.props
    return (
      <Modal show={popupError} onHide={onClose} className='warning-alert'>
        <Modal.Header closeButton>
          <Modal.Title>Error</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {messages && messages.length > 0 ? messages[0] : ''}
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={onClose}>Close</Button>
        </Modal.Footer>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/modals/WarningModal.js